import { TTableColumn } from "./TTableColumn";

export type THistoryTableConfig = {
	columns: TTableColumn[];
	additionalSensors: string[];
};

export const emptyHistoryTAbleConfig = { columns: [], additionalSensors: [] };
